:host {
    --wcs-editable-field-label-color: var(--wcs-semantic-color-text-primary);
    --wcs-editable-field-label-font-weight: var(--wcs-semantic-font-weight-book);
    --wcs-editable-field-label-gap: var(--wcs-semantic-spacing-base);
    --wcs-editable-field-label-font-size: var(--wcs-semantic-font-size-m);

    --wcs-editable-field-background-color: var(--wcs-semantic-color-background-control-default);
    --wcs-editable-field-value-font-weight: var(--wcs-semantic-font-weight-medium);
    --wcs-editable-field-value-color-default: var(--wcs-semantic-color-text-primary);
    --wcs-editable-field-value-color-hover: var(--wcs-semantic-color-text-primary);
    --wcs-editable-field-value-color-readonly: var(--wcs-semantic-color-text-tertiary);
    --wcs-editable-field-height-m: var(--wcs-semantic-size-m);
    --wcs-editable-field-height-l: var(--wcs-semantic-size-l);
    --wcs-editable-field-font-size-m: var(--wcs-semantic-font-size-m);
    --wcs-editable-field-font-size-l: var(--wcs-semantic-font-size-l);

    --wcs-editable-field-border-radius: var(--wcs-semantic-border-radius-base);
    --wcs-editable-field-border-width: var(--wcs-semantic-border-width-default);
    --wcs-editable-field-border-width-focus: var(--wcs-semantic-border-width-large);
    --wcs-editable-field-border-width-hover: var(--wcs-semantic-border-width-default);
    --wcs-editable-field-border-color-default: var(--wcs-semantic-color-border-primary);
    --wcs-editable-field-border-color-hover: var(--wcs-semantic-color-border-control-focus);
    --wcs-editable-field-border-color-focus: var(--wcs-semantic-color-border-control-focus);
    --wcs-editable-field-border-style: var(--wcs-semantic-border-style-focus-control);

    --wcs-editable-field-padding-vertical-m: 0;
    --wcs-editable-field-padding-vertical-l: 0;
    --wcs-editable-field-padding-horizontal-m: var(--wcs-semantic-spacing-large);
    --wcs-editable-field-padding-horizontal-l: var(--wcs-semantic-spacing-large);

    --wcs-editable-field-icon-color-readonly: var(--wcs-semantic-color-text-tertiary);

    // Default
    --wcs-editable-field-host-padding: var(--wcs-editable-field-padding-vertical-m) var(--wcs-editable-field-padding-horizontal-m);
    --wcs-editable-field-host-height: var(--wcs-editable-field-height-m);
    --wcs-editable-field-font-size: var(--wcs-editable-field-font-size-m);

    display: block;

    .display-none {
        display: none !important;
    }

    .label {
        margin-bottom: var(--wcs-editable-field-label-gap);
        font-weight: var(--wcs-editable-field-label-font-weight);
        font-size: var(--wcs-editable-field-label-font-size);
        color: var(--wcs-editable-field-label-color);
    }

    .edit-container {
        display: flex;
        width: 100%;

        .visually-hidden {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            clip-path: inset(50%);
            white-space: nowrap;
            outline: 0;
            outline-offset: 0;
        }
    }

    button.display-container {
        // Reset native button styles
        width: 100%;
        border: none;
        font-family: inherit;
        text-align: start;

        box-sizing: border-box;
        wcs-mat-icon {
            display: none;
        }
        min-height: var(--wcs-editable-field-host-height);
        white-space: break-spaces;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: var(--wcs-editable-field-background-color);
        border-radius: var(--wcs-editable-field-border-radius);
        font-size: var(--wcs-editable-field-font-size);
        line-height: 1.5;
        font-weight: var(--wcs-editable-field-value-font-weight);
        color: var(--wcs-editable-field-value-color-default);
        padding: var(--wcs-editable-field-host-padding);
        outline: var(--wcs-editable-field-border-style) var(--wcs-editable-field-border-width) var(--wcs-editable-field-border-color-default);
    }

    .load-container {
        box-sizing: border-box;
        min-height: var(--wcs-editable-field-host-height);
        white-space: pre;
        display: flex;
        justify-content: space-between;
        background-color: var(--wcs-editable-field-background-color);
        border-radius: var(--wcs-editable-field-border-radius);
        font-size: var(--wcs-editable-field-font-size);
        line-height: 1.5;
        font-weight: var(--wcs-editable-field-value-font-weight);
        color: var(--wcs-editable-field-value-color-default);
        padding: var(--wcs-editable-field-host-padding);
        outline: var(--wcs-editable-field-border-style) var(--wcs-editable-field-border-width) var(--wcs-editable-field-border-color-default);
        align-items: center;
    }

    wcs-spinner {
        height: 24px;
        width: 24px;
    }

    .readonly-icon {
        fill: var(--wcs-editable-field-icon-color-readonly);
    }
}

:host([readonly]) {
    --wcs-editable-field-background-color: var(--wcs-semantic-color-background-control-readonly);

    .display-container {
        color: var(--wcs-editable-field-value-color-readonly);

        &:focus-visible {
            outline: var(--wcs-editable-field-border-style) var(--wcs-editable-field-border-width-focus) var(--wcs-editable-field-border-color-default);
        }
    }
}

:host(:not([readonly])) {
    .display-container:hover,
    .display-container:focus-visible {
        wcs-mat-icon {
            display: flex;
            align-items: center;
        }
    }

    .display-container:hover {
        color: var(--wcs-editable-field-value-color-hover);
        cursor: pointer;
        outline: var(--wcs-editable-field-border-style) var(--wcs-editable-field-border-width-hover) var(--wcs-editable-field-border-color-hover);
    }

    .display-container:focus-visible {
        outline: var(--wcs-editable-field-border-style) var(--wcs-editable-field-border-width-focus) var(--wcs-editable-field-border-color-focus);
    }
}

:host([size=l]) {
    --wcs-editable-field-host-padding: var(--wcs-editable-field-padding-vertical-l) var(--wcs-editable-field-padding-horizontal-l);
    --wcs-editable-field-host-height: var(--wcs-editable-field-height-l);
    --wcs-editable-field-font-size: var(--wcs-editable-field-font-size-l);
}

:host([size=m]) { // Default
    --wcs-editable-field-host-padding: var(--wcs-editable-field-padding-vertical-m) var(--wcs-editable-field-padding-horizontal-m);
    --wcs-editable-field-host-height: var(--wcs-editable-field-height-m);
    --wcs-editable-field-font-size: var(--wcs-editable-field-font-size-m);
}
